import React, { useState } from 'react';
import MainCalculatorsList from '../MainCalculators';
import RelatedLinks from '../RelatedLinks';
import SilverZakatTable from './SilverZakatTable';
import { SERVER_URL } from '../ConstantsEN';
import { Silver_Zakat_EndPoint } from '../ConstantsEN';
import { CalculatorsType } from '../ConstantsEN';
import SharedHelmet from "../Helmet";
const TITLE = 'Silver Zakat Calculator 2026 - Silver Zakat Nisab Calculator';
const DESCRIPTION = 'The Silver Zakat Calculator is a tool used to calculate the amount of Zakat due on silver according to Islamic Sharia rules. This calculator is used to calculate the financial amount that must be paid as Zakat on owned silver.';
const KEYWORDS = 'Silver Zakat, Calculate Silver Zakat';
const OG_URL = 'https://do-calculate.com/calculator/en/silver-zakat/';
const apiEndpoint = `${SERVER_URL}/${Silver_Zakat_EndPoint}`;
function SilverZakatCalculator() {
    const [yearType, setYearType] = useState('');
    const [gramPriceSilver, setGramPriceSilver] = useState(0);
    const [silverWeight, setSilverWeight] = useState(0);
    const [result, setRestul] = useState(null);
    const [statusCode, setStatusCode] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const handleSilverWeightChange = (event) => {
        setSilverWeight(event.target.value);
    };
    const handleYearTypeChange = (event) => {
        setYearType(event.target.value);
    };
    const handleGramPriceSilverChange = (event) => {
        setGramPriceSilver(event.target.value);
    };
    const calculateSilverZakat = async () => {
        setIsLoading(true);
        try {
            const response = await fetch(apiEndpoint, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ silverWeight, gramPriceSilver, yearType }),
            });
            const data = await response.json();
            setStatusCode(response.status);
            if (response.ok) {
                setRestul(data.result);
            } else {
                setRestul(null);
            }
        } catch (error) {
            console.error(error);
        } finally {
            setIsLoading(false);
        }
    };
    return (
        <div>
              <SharedHelmet
             TITLE={TITLE}
             DESCRIPTION={DESCRIPTION}
             KEYWORDS={KEYWORDS}
             OG_URL={OG_URL}
           />
            <div className="row">
                <div className="col-12 col-md-8">
                    <br />
                    <div className="bg-success text-white text-center" style={{ height: '40px', }}>
                        <h1 style={{ fontSize: '15px' }}>  Calculate Silver Zakat for Any Purity </h1>
                    </div>
                    <div className="border border-light">
                        <div className="row">
                            <div>
                                The Silver Zakat Calculator is a tool used to calculate the amount of Zakat due on silver according to Islamic Sharia rules. This calculator is used to calculate the financial amount that must be paid as Zakat on owned silver.
                                <br />
                                <hr />
                            </div>
                            <br />
                        </div>
                        <div className="row">
                            <div className="col-sm-12 col-md-5 calculatorStyle">
                                <div className='p-3 mb-2 bg-success text-white'>
                                    Silver Zakat
                                </div>
                                <hr />
                                <br />
                                <div className="form-group d-flex align-items-center">
                                    <b>
                                        <label htmlFor='yearType' >Year Type</label>
                                    </b>
                                    <div className="form-check form-check-inline">
                                        <input
                                            type="radio"
                                            name="yearType"
                                            value="gregorian"
                                            id="gregorian"
                                            checked={yearType === "gregorian"}
                                            onChange={handleYearTypeChange}
                                            className="form-check-input"
                                        />
                                        <label className="form-check-label" htmlFor="gregorian">
                                            Gregorian
                                        </label>
                                    </div>
                                    <div className="form-check form-check-inline">
                                        <input
                                            type="radio"
                                            name="yearType"
                                            value="hijri"
                                            id="hijri"
                                            checked={yearType === "hijri"}
                                            onChange={handleYearTypeChange}
                                            className="form-check-input"
                                        />
                                        <label className="form-check-label" htmlFor="hijri">
                                            Hijri
                                        </label>
                                    </div>
                                </div>
                                <br />
                                <div className="form-group d-flex align-items-center">
                                    <b>
                                        <label htmlFor="silverWeightNumber" className="form-label ms-2">Total Silver Weight </label>
                                    </b>
                                    <input
                                        type="number"
                                        id="silverWeightNumber"
                                        value={silverWeight}
                                        onChange={handleSilverWeightChange}
                                        className="form-control ml-2"
                                        style={{ width: '75px' }}
                                    />
                                    <div className="input-group-append">
                                        <span className="input-group-text">g</span>
                                    </div>
                                </div>
                                <br />
                                <div className="form-group d-flex align-items-center">
                                    <b>
                                        <label htmlFor="gramPriceGoldNumber" className="form-label ms-2">Silver Gram Price (99.9 Purity)</label>
                                    </b>
                                    <input
                                        type="number"
                                        id="gramPriceGoldNumber"
                                        value={gramPriceSilver}
                                        onChange={handleGramPriceSilverChange}
                                        className="form-control ml-2"
                                        style={{ width: '75px' }}
                                    />
                                </div>
                                <br/>                                <hr />
                                <button className="btn btn-success" style={{ fontSize: '20px' }} onClick={
                                    calculateSilverZakat} disabled={isLoading}>
                                    {isLoading ? (
                                        <div className="spinner-border spinner-border-sm" role="status">
                                            <span className="visually-hidden">Loading...</span>
                                        </div>
                                    ) : (
                                        'Calculate'
                                    )}
                                </button>
                            </div>
                            <div className="col-sm-12 col-md-7">
                                <br />
                                {statusCode === 400 && <div className="alert alert-warning"><b><u>Error:</u></b> Please enter all fields correctly. </div>}
                                {result &&
                                    (
                                        <div>
                                            <h4><div className="p-3 mb-2 bg-success text-white">Results: </div></h4>
                                            <hr />
                                            <SilverZakatTable result={result}></SilverZakatTable>
                                        </div>
                                    )}
                            </div>
                        </div>
                        <hr />
                        <div className="row">
                            <RelatedLinks />
                            <hr />
                        </div>
                    </div>
                </div>
                <div className="col" >
                    <br />
                    <MainCalculatorsList CalculatorsTypeId={CalculatorsType.islamicCalculators}></MainCalculatorsList>
                    <br />
                </div>
            </div>
            <div className="row" style={{ height: 'auto' }} >
                <div className="col-12 col-md-8">
                    <div className="info-sections-container">
                        <div className="info-section">
                            <div className="info-section-header">Description of Silver Zakat Calculator</div>
                            <div className="info-section-body">
                                <h2 style={{ fontSize: '15px' }}>How to Calculate Silver Zakat</h2>
                                <br />
                                The equation relies on several variables and parameters, including the weight of silver, the gram price, and the type of calendar (Hijri or Gregorian). The Zakat threshold for silver (nisab) is determined, and it is set at 595 grams according to the provided equation.
                                <br/>                                If the weight of silver exceeds the Zakat threshold, then Silver Zakat becomes due. The value of Silver Zakat is calculated using a specified percentage for Zakat. The Zakat percentage considered can either be based on the Hijri calendar (2.5%) or the Gregorian calendar (2.577%), depending on the selected calendar.
                                <br/>                                After calculating the value of Silver Zakat, the amount is adjusted appropriately for presentation, and the final value of Silver Zakat along with the monetary amount is provided.
                                <br/>                                The calculator provides the final results in the form of an object containing the amount of Silver Zakat, the status of Silver Zakat (required or not), the Zakat threshold for silver, and the monetary amount of Silver Zakat.
                                <br />
                                <hr />
                                <b>Source: </b>
                                <a href="https://www.islamic-relief.me/%D8%AD%D8%B3%D8%A7%D8%A8-%D8%B2%D9%83%D8%A7%D8%A9-%D8%A7%D9%84%D9%85%D8%A7%D9%84/">
                                    Islamic Relief Worldwide
                                </a> <br />
                                <b>Last Reviewed On: </b>
                                04/07/2023
                            </div>
                        </div>
                    </div>
                </div>
            </div> <br />
        </div>
    );
}
export default SilverZakatCalculator;
